import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';

import Question from '@evidentid/ido-lib/interfaces/Question';
import { pickListenerAttrs } from '@evidentid/vue-commons/utils/attrsListeners';

import { Status, VerificationFailureReason, VerificationResult } from '@/store/interfaces/IdoState';

import Field from './Field';

class FieldComponentConstructor<Value = any> extends Vue {
    @Prop(Object)
    protected question!: Question;

    @Prop(Object)
    protected field!: Field<Value>;

    @Prop(Boolean)
    protected valid!: boolean;

    @Prop(Boolean)
    protected submitting!: boolean;

    @Prop(Number)
    protected questionsLeft!: number;

    @Prop()
    protected value!: Value;

    @Prop({ type: String, default: Status.uninitialized })
    protected delegationStatus!: Status;

    @Prop({ type: String, default: null })
    protected delegationUrl!: string | null;

    @Prop({ type: Number, default: null })
    protected delegationExpiresAt!: number | null;

    @Prop(String)
    protected verificationResult!: VerificationResult;

    @Prop({ type: String, default: null })
    protected verificationFailureReason!: VerificationFailureReason | null;

    @Prop({ type: Number, default: 0 })
    protected verificationsFailed!: number;

    @Prop({ type: Number, default: 0 })
    protected verificationResolutionAttempts!: number;

    @Prop({ type: Boolean, default: false })
    protected bare!: boolean;

    // PRODUCT-26110 Task 10 (INSTANCE_LISTENERS): subclasses forward `v-bind="$props"`
    // (declared props only, deliberately excluding raw attrs -- `inheritAttrs: false`)
    // plus listeners down to a nested field-screen component. Vue 3 merges `$listeners`
    // into `$attrs`, so a blanket `v-bind="$attrs"` here would newly leak raw attrs
    // that were never forwarded before -- pick just the `onXxx` (listener) keys back
    // out instead.
    protected get listenerAttrs(): Record<string, unknown> {
        return pickListenerAttrs(this.$attrs);
    }

    // PRODUCT-26110 Task 10 (INSTANCE_LISTENERS): Vue's template compiler rejects two
    // bare `v-bind` directives on the same element ("Duplicate attribute"), so
    // `v-bind="$props"` and `v-bind="listenerAttrs"` must be merged into one object
    // wherever a subclass previously wrote `v-bind="$props" v-on="$listeners"`.
    protected get propsWithListenerAttrs(): Record<string, unknown> {
        return { ...this.$props, ...this.listenerAttrs };
    }
}

// Trick TypeScript, so it will not detect that the class is decorated
// It is required for proper IDE completion
let FieldComponent = FieldComponentConstructor;
// @ts-ignore: the index signature breaks somewhere there
FieldComponent = Mixins(Component(FieldComponent));

export default FieldComponent;
